import { ShipmentStatus } from 'src/app/types/shipment-status';

export class ShipmentStatModel {
  count: number = 0;
  status: ShipmentStatus = ShipmentStatus.Open;
};
